
import { defineComponent, onMounted, ref, watch } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";
import moment from "moment";
import { getScraperSosmed } from "../streams";
import Swal from "sweetalert2/dist/sweetalert2.js";

interface MediaSosialForm {
  source: string;
  account: string;
  id_origin: string;
  content: string;
  date: string;
  emotion: string;
  engagement_count: number;
  engagement_detail: {
    like: number;
    comment: number;
    repost: number;
    share: number;
  };
  followers: number;
  url: string;
  sentiment: string;
  carousel: [];
  esmr: number;
  id_account: string;
  photo: string;
  profile_image: string;
}

export default defineComponent({
  name: "input-berita-threads",
  components: {
    ErrorMessage,
    Field,
    Form,
  },
  emit: ["success-input"],
  setup(props, { emit }) {
    const submitThreads = ref<HTMLElement | null>(null);
    const getDataButton1 = ref<HTMLElement | null>(null);
    const loading = ref(false);
    const media_options = ref([]);
    const valueContent = ref("");
    const rateAccountMedia = ref(0);
    const lebarAccountMedia = ref(0);
    const isEnableField = ref(true);
    const threads_url = ref("");
    const contentError = ref("");
    const dateError = ref("");

    const MediaSosialForm = ref<MediaSosialForm>({
      source: "threads",
      account: "",
      id_origin: "",
      content: "",
      date: "",
      emotion: "",
      engagement_count: 0,
      engagement_detail: {
        like: 0,
        comment: 0,
        repost: 0,
        share: 0,
      },
      followers: null as any,
      url: "",
      sentiment: "",
      carousel: [],
      esmr: 0,
      id_account: "",
      photo: "",
      profile_image: "",
    });

    const MediaSosialFormValidator = Yup.object().shape({
      url: Yup.string().required().label("URL Berita"),
      account: Yup.string().required("Nama Akun is a required field").label("Nama Akun"),
      url_account: Yup.string().required("URL Akun is a required field").label("URL Akun"),
      date: Yup.string().nullable().label("Tanggal Berita"),
      engagement_detail_like: Yup.number()
        .min(0)
        .required()
        .label("Jumlah Like"),
      engagement_detail_comment: Yup.number()
        .min(0)
        .required()
        .label("Jumlah Komentar"),
      engagement_detail_repost: Yup.number()
        .min(0)
        .required()
        .label("Jumlah Repost"),
      engagement_detail_share: Yup.number()
        .min(0)
        .required()
        .label("Jumlah Share"),
      followers: Yup.number().min(0).required().label("Jumlah Follower"),
      emotion: Yup.string().nullable().label("Emotion"),
      sentiment: Yup.string().nullable().label("Sentimen"),
    });

    watch(
      () => MediaSosialForm.value.date,
      (newValue) => {
        if (newValue && newValue !== "") {
          dateError.value = "";
        }
      }
    );

    const resetForm = () => {
      threads_url.value = "";
      isEnableField.value = true;
      contentError.value = "";
      dateError.value = "";
      MediaSosialForm.value = {
        source: "threads",
        account: "",
        id_origin: "",
        content: "",
        date: "",
        emotion: "",
        engagement_count: 0,
        engagement_detail: {
          like: 0,
          comment: 0,
          repost: 0,
          share: 0,
        },
        followers: 0,
        url: "",
        sentiment: "",
        carousel: [],
        esmr: 0,
        id_account: "",
        photo: "",
        profile_image: "",
      };
    };

    const saveMedsos = () => {
      dateError.value = "";

      if (!MediaSosialForm.value.content || MediaSosialForm.value.content.trim() === "") {
        contentError.value = "Konten Berita is a required field";
        return;
      }
      contentError.value = "";

      if (!MediaSosialForm.value.date || MediaSosialForm.value.date === "") {
        dateError.value = "Tanggal Berita harus diisi";
        return;
      }

      if (submitThreads.value) {
        submitThreads.value.setAttribute("data-kt-indicator", "on");
        let loadout = MediaSosialForm.value;

        loadout.engagement_count =
          loadout.engagement_detail.like +
          loadout.engagement_detail.comment +
          loadout.engagement_detail.repost +
          loadout.engagement_detail.share;

        loadout.date = moment(loadout.date).format("YYYY-MM-DD HH:mm:ss");
        let params = {
          data: [loadout],
        };
        ApiService.post("/streams/save-socmed", { data: params })
          .then((response) => {
            if (response.status == 200) {
              const id = response.data.inserted_id.split(",");
              emit("success-input", id);
              Swal.fire({
                position: "top-end",
                icon: "success",
                toast: true,
                title: "Berhasil! Berita berhasil disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
              resetForm();
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                toast: true,
                title: "Gagal! Berita gagal disimpan",
                showConfirmButton: false,
                timer: 3000,
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              position: "top-end",
              icon: "error",
              toast: true,
              title: "Gagal! Terjadi kesalahan pada server",
              showConfirmButton: false,
              timer: 3000,
            });
          })
          .finally(() => {
            submitThreads.value?.removeAttribute("data-kt-indicator");
          });
      }
    };

    const remoteMethod = (query) => {
      if (query.length > 2) {
        loading.value = true;
        let url = "/media?media_like=" + query + "&limit=100&page=1";
        if (MediaSosialForm.value["source"] != "") {
          url = url + "&source=" + MediaSosialForm.value["source"];
        }
        ApiService.get(url)
          .then((response) => {
            media_options.value = response.data.data;
            return media_options.value;
          })
          .catch((error) => {
            loading.value = false;
          })
          .finally(() => {
            loading.value = false;
          });
        return [];
      } else {
        media_options.value = [];
      }
    };

    const convertText = () => {
      if (MediaSosialForm.value.content != null) {
        let text = MediaSosialForm.value.content.split("\n\n");
        let newText = "";

        for (let i = 0; i < text.length; i++) {
          let perTextArray = text[i].split("\n");
          for (let j = 0; j < perTextArray.length; j++) {
            if (perTextArray[j].charAt(perTextArray[j].length - 1) == "-") {
              newText += perTextArray[j].replace(/-/g, "");
            } else {
              newText += perTextArray[j] + " ";
            }
          }
          newText += "\n";
        }
        MediaSosialForm.value.content = newText;
        if (newText.trim()) {
          contentError.value = "";
        }
      }
    };

    const getContentUrl = async () => {
      getDataButton1.value?.setAttribute("data-kt-indicator", "on");
      getDataButton1.value?.setAttribute("disabled", "disabled");

      let url = "/scraper/threads/post";
      let params = {
        url: threads_url.value.trim(),
      };

      let response = await getScraperSosmed(url, params);

      if (response["error"] || response["result"]?.error) {
        Swal.fire({
          text: "Gagal Mendapatkan Informasi Berita! Silahkan Masukkan Ulang URL Postingan atau Masukkan URL Postingan Lain...",
          icon: "error",
          confirmButtonText: "Ok",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-light-primary",
          },
        });
        getDataButton1.value?.removeAttribute("data-kt-indicator");
        getDataButton1.value?.removeAttribute("disabled");
      } else {
        const result = response["result"];

        // Format date dengan benar
        let dateValue = "";

        if (result.date) {
          let rawDate = result.date;

          if (rawDate.$date) {
            rawDate = rawDate.$date;
          }

          const parsedDate = moment(rawDate);

          if (parsedDate.isValid()) {
            dateValue = parsedDate.format("YYYY-MM-DD HH:mm:ss");
          }
        }

        MediaSosialForm.value.date = dateValue;

        if (dateValue) {
          dateError.value = "";
        }

        MediaSosialForm.value.account = result.account || "";
        MediaSosialForm.value.id_origin = result.id_origin || "";
        MediaSosialForm.value.url = result.url || threads_url.value;
        MediaSosialForm.value.content = result.content || "";
        MediaSosialForm.value.id_account = result.id_account || "";
        MediaSosialForm.value.profile_image = result.profile_picture || "";

        // Engagement detail
        if (result.engagement_detail) {
          MediaSosialForm.value.engagement_detail.like = result.engagement_detail.like || 0;
          MediaSosialForm.value.engagement_detail.comment = result.engagement_detail.comment || 0;
          MediaSosialForm.value.engagement_detail.repost = result.engagement_detail.repost || 0;
          MediaSosialForm.value.engagement_detail.share = result.engagement_detail.share || 0;
        }

        // Engagement count total
        MediaSosialForm.value.engagement_count = result.engagement_count || 0;
        MediaSosialForm.value.followers = result.followers || null;

        if (result.file_sources && result.file_sources.length > 0) {
          const photoSource = result.file_sources.find(item => item.type === "photo");
          if (photoSource && photoSource.url && photoSource.url.length > 0) {
            MediaSosialForm.value.photo = photoSource.url[0];
          }
        }

        if (result.file_sources && result.file_sources.length > 0) {
          const allPhotos = result.file_sources
            .filter(item => item.type === "photo")
            .flatMap(item => item.url || []);
          MediaSosialForm.value.carousel = allPhotos;
        }

        isEnableField.value = false;

        if (MediaSosialForm.value.content && MediaSosialForm.value.content.trim()) {
          contentError.value = "";
        }

        getDataButton1.value?.removeAttribute("data-kt-indicator");
        getDataButton1.value?.removeAttribute("disabled");
      }
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs("Input Berita", ["Berita"]);
    });

    return {
      threads_url,
      submitThreads,
      saveMedsos,
      resetForm,
      MediaSosialForm,
      MediaSosialFormValidator,
      loading,
      remoteMethod,
      media_options,
      convertText,
      valueContent,
      isNumber: (evt) => {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          (charCode !== 46 || charCode !== 190)
        ) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      rateAccountMedia,
      lebarAccountMedia,
      getContentUrl,
      isEnableField,
      getDataButton1,
      contentError,
      dateError,
    };
  },
  methods: {
    setEmotion(value) {
      if (value == this.MediaSosialForm.emotion) {
        this.MediaSosialForm.emotion = "";
      } else {
        this.MediaSosialForm.emotion = value;
      }
    },
    setSentiment(value) {
      if (value == this.MediaSosialForm.sentiment) {
        this.MediaSosialForm.sentiment = "";
      } else {
        this.MediaSosialForm.sentiment = value;
      }
    },
  },
});
